/*eslint-disable*/
import React, { Component } from "react";
// reactstrap components
import { Card, CardHeader, Col, Row } from "reactstrap";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import {
  countByInternal,
  getAllProperties,
  getAllUsers,
  getMe,
  getMeAuth,
} from "../utils/store/actions/users.actions";
import { getAllTeams } from "../utils/store/actions/teams.actions";
import { connect } from "react-redux";
import { Button, Paper } from "@material-ui/core";
import { baseUriUsers } from "../utils/uri";
import axios from "axios";
import GroupIcon from "@material-ui/icons/Group";
import RecentActorsIcon from "@material-ui/icons/RecentActors";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import { withTranslation } from "react-i18next";

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: "transparent",
      margin: "auto",
      overflow: "hidden",
      boxShadow: "none",
      marginTop: "10%",
      marginBottom: "5%",
    },
    searchBar: {
      backgroundColor: "#F5F6FF",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    searchInput: {
      backgroundColor: "#F5F6FF",
      fontSize: theme.typography.fontSize,
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
    },
    contentWrapper: {
      margin: "40px 16px",
    },
    rowDashboard: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "3vh",
    },
  });

class Index extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      activeNav: 1,
      parties: [],
      chartExample1Data: "data1",
    };
  }
  getParties = async () => {
    const response = await axios.get(
      `${baseUriUsers}/service-user/v1/parties/values`
    );
    return response.data;
  };
  async componentDidMount() {
      await this.props.getMe();
      await this.props.getAllProperties();
      await this.props.getAllUsers();
      await this.props.countByInternal();
      await this.props.getAllTeams();
      await this.getParties().then((part) => {
        this.setState({ parties: part });
      });
  };

  toggleNavs = (e: React.MouseEvent, index: number) => {
    e.preventDefault();
    const { chartExample1Data } = this.state;
    this.setState({
      activeNav: index,
      chartExample1Data: chartExample1Data === "data1" ? "data2" : "data1",
    });
    const wow = () => {
      console.log(this.state);
    };
    wow.bind(this);
    setTimeout(() => wow(), 1000);
    // this.chartReference.update();
  };

  render() {
    const { activeNav, chartExample1Data } = this.state;
    const { classes, LocalUser, t } = this.props;
    const { Users } = this.props;
    const { Teams } = this.props;
    return (
      <>
        {/* Page content */}
        <Paper className={classes.paper}>
          <Row className={classes.rowDashboard}>
            {((LocalUser && LocalUser.role && LocalUser.role.userCanView) ||
              this.props.Users?.get_properties?.find(
                (property: { key: string; value: boolean }) =>
                  property.key === "IS_V4_AVAILABLE"
              )?.value === "true") && (
              <Col xl="3">
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">{t("USERS")}</h3>
                      </div>
                      <Button href="/admin/users/user-list">
                        {" "}
                        <GroupIcon
                          style={{
                            color: "ae0064",
                            width: "30px",
                            height: "30px",
                          }}
                        />
                      </Button>
                    </Row>
                  </CardHeader>
                </Card>
              </Col>
            )}
            {((LocalUser && LocalUser.role && LocalUser.role.teamCanView) ||
              this.props.Users?.get_properties?.find(
                (property: { key: string; value: boolean }) =>
                  property.key === "IS_V4_AVAILABLE"
              )?.value === "true") && (
              <Col xl="3">
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">{t("TEAMS")}</h3>
                      </div>
                      <Button href="/admin/users/teams">
                        <RecentActorsIcon
                          style={{
                            color: "ae0064",
                            width: "30px",
                            height: "30px",
                          }}
                        />
                      </Button>
                    </Row>
                  </CardHeader>
                </Card>
              </Col>
            )}
          </Row>
          <Row className={classes.rowDashboard}>
            {((LocalUser &&
              LocalUser.role &&
              LocalUser.role.defaultAuthorizationCanView) ||
              !(
                (this.props.Users?.get_properties || [])?.find(
                  (property: { key: string; value: boolean }) =>
                    property.key === "IS_V4_AVAILABLE"
                )?.value === "true"
              )) && (
              <Col xl="3">
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">{t("ROLES")}</h3>
                      </div>
                      <Button href="/admin/users/users-roles">
                        <AccountBoxIcon
                          style={{
                            color: "ae0064",
                            width: "30px",
                            height: "30px",
                          }}
                        />
                      </Button>
                    </Row>
                  </CardHeader>
                </Card>
              </Col>
            )}
            {((LocalUser &&
              LocalUser.role &&
              LocalUser.role.adminCanEditProduit) ||
              this.props.Users?.get_properties?.find(
                (property: { key: string; value: boolean }) =>
                  property.key === "IS_V4_AVAILABLE"
              )?.value === "true") && (
              <Col xl="3">
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">{t("FUNDS_PLURAL")}</h3>
                      </div>
                      <Button href="/admin/funds">
                        <RecentActorsIcon
                          style={{
                            color: "ae0064",
                            width: "30px",
                            height: "30px",
                          }}
                        />
                      </Button>
                    </Row>
                  </CardHeader>
                </Card>
              </Col>
            )}
          </Row>
          {((LocalUser && LocalUser.role && LocalUser.role.userCanView) ||
            this.props.Users?.get_properties?.find(
              (property: { key: string; value: boolean }) =>
                property.key === "IS_V4_AVAILABLE"
            )?.value === "true") && (
            <Row
              className={classes.rowDashboard}
              style={{ marginTop: "10%", marginBottom: "5%" }}
            >
              <Col>
                <Card
                  className="shadow"
                  style={{
                    marginLeft: "15%",
                    height: "100%",
                    backgroundColor: "ae0064",
                  }}
                >
                  <CardHeader
                    className="border-0"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignContent: "center",
                      alignItems: "center",
                      margin: "20%",
                    }}
                  >
                    <Row className="align-items-center">
                      <div className="col">
                        <h3
                          style={{
                            color: "#000060",
                            fontSize: "24px",
                            paddingBottom: "20px",
                          }}
                          className="mb-0"
                        >
                          {t("TOTAL_INTERNAL_USERS")}
                        </h3>
                      </div>
                    </Row>
                    <Row>
                      <div style={{ color: "#ae0064", fontSize: "30px" }}>
                        {Users.countUser?.internal}
                      </div>
                    </Row>
                  </CardHeader>
                </Card>
              </Col>
              <Col>
                <Card
                  className="shadow"
                  style={{
                    height: "100%",
                    marginRight: "15%",
                    backgroundColor: "ae0064",
                  }}
                >
                  <CardHeader
                    className="border-0"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignContent: "center",
                      alignItems: "center",
                      margin: "20%",
                    }}
                  >
                    <Row className="align-items-center">
                      <div className="col">
                        <h3
                          style={{
                            color: "#000060",
                            fontSize: "24px",
                            paddingBottom: "20px",
                          }}
                          className="mb-0"
                        >
                          {t("TOTAL_EXTERNAL_USERS")}
                        </h3>
                      </div>
                    </Row>
                    <Row>
                      <div style={{ color: "#ae0064", fontSize: "30px" }}>
                        {Users.countUser?.external}
                      </div>
                    </Row>
                  </CardHeader>
                </Card>
              </Col>
            </Row>
          )}
        </Paper>
      </>
    );
  }
}

const mapStateToProps = (state: {
  Users: UsersState;
  Teams: TeamsState;
  LocalUser: LocalUserState;
}) => ({
  LocalUser: state.LocalUser,
  Users: state.Users,
  Teams: state.Teams,
});

const mapDispatchToProps = {
  getMe,
  getMeAuth,
  getAllProperties,
  getAllUsers,
  getAllTeams,
  countByInternal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(Index)));
